import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();

  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };

  return (
    <div className="legal-page">
      <h1>About NeuCraft<span style={tmStyle}>™</span></h1>

      <section className="about-intro">
        <p>
          NeuCraft<span style={tmStyle}>™</span> is a small shop offering unique items designed with character and fun in mind. We launch with a limited selection of cool, creative pieces — and may expand over time with new gadgets and curiosities worth discovering. No fluff. Just interesting things you didn’t know you needed.
        </p>
      </section>

      <section className="about-support">
        <h2>Support</h2>
        <p>
          For product inquiries or support, please email <a href="mailto:support@neucraft.shop">support@neucraft.shop</a>.
        </p>
      </section>

      <div className="productpage-actions productpage-actions-row" style={{ justifyContent: 'flex-start', marginTop: '80px' }}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{ cursor: 'pointer' }}>
          &larr; Home
        </button>
      </div>
    </div>
  );
}